/*
 * @Author: Sam
 * @Date: 2020-07-29 14:26:59
 * @LastEditTime: 2022-02-16 09:28:07
 * @LastEditors: Sam
 * @Description:Handsontable 授权密钥
 * @FilePath: \resourcesf:\thework\tofba-client\src\utils\config.js
 * @如过期，请重新生成
 */
const globalData = {
  licensekey: 'c31f9-59e99-1ca72-64f0d-cad87',
  // PRODUCT_IMAGES_SERVER : 'http://47.96.65.20/'
  path: process.env.VUE_APP_BASE_API,
  isNbEnv: false,
}
console.log('process.env.NODE_ENV :>> ', process.env.NODE_ENV)

switch (process.env.NODE_ENV) {
  case 'development':
    globalData.fileUrl = 'http://192.168.200.166:8086/'
    break
  case 'staging':
    globalData.fileUrl = 'http://192.168.200.166:8086/'
    break
  case 'prodNb':
    // 宁波
    globalData.fileUrl = 'http://47.96.65.20:8080/'
    globalData.isNbEnv = true
    break
  case 'devCs':
    // 长沙
    globalData.fileUrl = 'http://192.168.1.96:8080/'
    break
  default:
    // 生产环境
    globalData.fileUrl = 'http://www.tofba.com:8080/'
    break
}

console.log('globalData.fileUrl :>> ', globalData.fileUrl)

export default globalData
